import React from 'react';
   import ReactDOM from 'react-dom/client';
   import RebalancingAssistant from './rebalancing-assistant';

   const root = ReactDOM.createRoot(document.getElementById('root'));
   root.render(<RebalancingAssistant />);